/**
 * View component for /admin/users/:userId
 *
 * redirects to the rome admin user view
 */

// import primary libraries
import React from 'react';
import { withRouter } from 'react-router-dom';

import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminSingleUser extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match } = this.props;
    const userListUrl = `${window.hubUrl}/super/users/${match.params.userId}`;
    window.location.assign(userListUrl);
  }

  render() {
    return <div>Loading...</div>
  }
}

export default withRouter(AdminSingleUser);



// WEBPACK FOOTER //
// modules/user/views/AdminSingleUser.js.jsx